import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.recentlyViewed;

const getRecentlyViewed = createSelector(
  getData,
  recentlyViewed => recentlyViewed
);

export default getRecentlyViewed;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getRecentlyViewed.js